import type { ITableHeaderCellProps } from "app/components/React/Table/interfaces/ITableCellProps";
import { StyledHeaderCell, StyledHeaderCellText } from "./styles";

export const HeaderCellBold = ({ displayName, className }: ITableHeaderCellProps) => {
    return (
        <StyledHeaderCell className={className}>
            <StyledHeaderCellText data-automation="header-cell.text">{displayName}</StyledHeaderCellText>
        </StyledHeaderCell>
    );
};
